<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      title="Confirm"
      hide-header-close
      id="mymodal"
      ref="test"
    >
      <div>
        <label>
          <h4>Do you really want to update Status?</h4>
        </label>
        <div class="text-right">
          <button
            @click.prevent.stop="okUpdateStatus()"
            class="btn-blue mw-auto mr-3"
          >
            OK
          </button>
          <button
            @click.prevent.stop="cancelUpdateStatus()"
            class="btn-blue mw-auto mr-3"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>

    <div class="page-container">
      <div class="row pb-3">
        <div class="col-6 align-self-center">
          <div class="section-title">
            {{ $t("OnDemand Master Cinema Setting") }}
          </div>
        </div>
      </div>

      <div class="border-top border-bottom py-3 mb-3" v-if="false">
        <div class="row">
          <div class="col-4 align-self-cetner">
            <div class="searchbar-rounded">
              <input
                v-model="searchValue"
                type="search"
                :placeholder="$t('search')"
              />
            </div>
          </div>
          <div class="col-3 align-self-cetner">
            <multiselect
              :options="SearchLicenceList"
              :searchable="true"
              v-model="searchType"
              :placeholder="$tc('searchType')"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
          <div class="col-3 align-self-cetner">
            <button class="btn-blue" @click="onSearch">
              {{ $t("search") }}
            </button>
          </div>
          <div class="col-12">
            <b-pagination
              :total-rows="rows"
              :per-page="perPage"
              v-model="currentPage"
              aria-controls="my-table"
              class="mb-0 justify-content-end"
              @change="onChangePagination($event)"
              v-if="movieDetailList && movieDetailList.length > 0"
            ></b-pagination>
          </div>
        </div>
      </div>

      <div class="row mt-3" v-if="false">
        <div class="data-listing-table">
          <header v-if="false">
            <div class="row">
              <div class="col-2 align-self-center text-left">
                {{ $t("movieName") }}
              </div>
              <div class="col align-self-center">
                {{ $t("License Start Date") }}
              </div>
              <div class="col align-self-center">
                {{ $t("License End Date") }}
              </div>
              <div class="col align-self-center">
                {{ $t("showType") }}
              </div>
            </div>
          </header>

          <div class="data-body" v-if="Cinemas.length > 0">
            <div
              class="data-row"
              :key="cinema_index"
              v-for="(cinema_obj, cinema_index) in Cinemas"
            >
              <div class="cinemaBox">
                <div class="row mb-2">
                  <div class="col-2 text-left">
                    <h5>{{ cinema_obj.cine_name }}</h5>
                  </div>
                  <div class="col-2">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          v-model="cinema_obj.lead_hr"
                          type="text"
                          name="leadTimeMM"
                          id="leadTimeMM"
                          maxlength="2"
                          v-validate="'numeric'"
                        />
                        <label>Lead Time (HH)</label>
                      </div>
                      <!-- <Tooltip :title="'Time before cinema starts'" /> -->
                    </div>
                  </div>

                  <div class="col-2">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          v-model="cinema_obj.lead_mn"
                          type="text"
                          name="leadTimeMM"
                          id="leadTimeMM"
                          maxlength="2"
                          v-validate="'numeric'"
                        />
                        <label>Lead Time (MM)</label>
                      </div>
                      <!-- <Tooltip :title="'Time before cinema starts'" /> -->
                    </div>
                  </div>
                  <div class="col d-flex align-items-center">
                    <div
                      class="form-check mx-3"
                      v-for="(item, showTypeIndex) in ShowTypeArray"
                      :key="showTypeIndex"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :checked="
                          cinema_obj.cinemaShowType.findIndex(
                            (x) => x.booking_type_id == item.booking_type_id
                          ) !== -1
                        "
                        :id="`showtype${cinema_index}${showTypeIndex}`"
                        @change="saveShowType(item, cinema_obj)"
                      />
                      <label
                        class="form-check-label"
                        :for="`showtype${cinema_index}${showTypeIndex}`"
                      >
                        {{ item.screening_name }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div
                :id="'extraData-' + cinema_index"
                class="movie-license-collapse"
              >
                <div
                  class="d-flex align-items-center"
                  v-for="(
                    screen_obj, screen_index
                  ) in cinema_obj.new_screen_unique"
                  :key="screen_index"
                >
                  <div class="col-2">
                    <div class="my-1">
                      <div class="d-flex align-items-center my-1">
                        <!-- <p
                          class="m-0 cursor-pointer"
                         
                        >
                         Auditorium:
                        </p> -->

                        <div class="d-flex ml-2 mt-2">
                          <h6>{{ screen_obj.screen_name }}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- LEAD TIME HH-->
                  <div class="col-md-2 my-1">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          v-model="screen_obj.lead_hr"
                          type="text"
                          name="leadTimeHH"
                          id="leadTimeHH"
                          v-validate="'numeric'"
                        />
                        <label>Lead Time (HH)</label>
                      </div>
                      <!-- <Tooltip :title="'Time before cinema starts'" /> -->
                    </div>
                    <!-- <p
                          v-if="submitted && errors.has('leadTimeHH')"
                          class="error_message"
                        >
                          {{ errors.first("leadTimeHH") }}
                        </p> -->
                  </div>
                  <!-- LEAD TIME MM-->
                  <div class="col-md-2">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          v-model="screen_obj.lead_mn"
                          type="text"
                          name="leadTimeMM"
                          id="leadTimeMM"
                          maxlength="2"
                          v-validate="'numeric'"
                        />
                        <label>Lead Time (MM)</label>
                      </div>
                      <!-- <Tooltip :title="'Time before cinema starts'" /> -->
                    </div>
                  </div>
                  <div class="col d-flex">
                    <div
                      class="form-check mx-3"
                      v-for="(item, showTypeIndex) in ShowTypeArray"
                      :key="showTypeIndex"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :checked="
                          screen_obj.screenShowType.findIndex(
                            (x) => x.booking_type_id == item.booking_type_id
                          ) !== -1
                        "
                        :id="`showtype${cinema_index}${screen_index}${showTypeIndex}`"
                        @change="saveScreenShowType(item, screen_obj)"
                      />
                      <label
                        class="form-check-label"
                        :for="`showtype${cinema_index}${screen_index}${showTypeIndex}`"
                      >
                        {{ item.screening_name }}
                      </label>
                    </div>
                  </div>
                </div>
                <!-- <div class="d-flex justify-content-center">
                  <button
                    class="btn-blue"
                    @click="SaveSchedule(shiftsCLoseValue)"
                  >
                    {{ $t("save") }}
                  </button>
                </div> -->
                <!-- <div class="row mt-2">
                  <div
                    class="col-12"
                    v-if="getIntervals(shiftsCLoseValueIndex)"
                  >
                    <b-badge
                      pill
                      style="
                        margin-left: 2px;
                        margin-bottom: 2px;
                        color: #fff;
                        background-color: #007bff;
                        padding: 7px;
                      "
                      variant="primary"
                      v-for="(item_badge, index_bad) in getIntervals(
                        shiftsCLoseValueIndex
                      )"
                      :key="index_bad"
                      >{{ item_badge }}
                    </b-badge>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div v-else>
            <!-- No Records Found -->
            <NoRecords />
          </div>
        </div>
        <div class="col-md-12 text-center">
          <button class="btn-blue" @click.prevent.stop="saveSetting">
            {{ $t("Save & Close") }}
          </button>
        </div>
      </div>

      <div class="">
        <div
          class="data-row onDemandSection"
          :key="cinema_index"
          v-for="(cinema_obj, cinema_index) in Cinemas"
        >
          <div class="cinemaBox">
            <div class="row mb-2">
              <div class="col-2 text-left">
                <h5>{{ cinema_obj.cine_name }}</h5>
                <span class="text-muted">(Cinema Name)</span>
              </div>

              <div class="col-3">
                <div class="row pl-4 pr-2">
                  <div class="col-6 p-1">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          style="text-align:right"
                          placeholder="."
                          v-model="cinema_obj.lead_hr"
                          type="text"
                          name="leadTimeMM"
                          id="leadTimeMM"
                          maxlength="2"
                          v-validate="'numeric'"
                        />
                        <label>(HH)</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 p-1">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                        style="text-align:right"
                          placeholder="."
                          v-model="cinema_obj.lead_mn"
                          type="text"
                          name="leadTimeMM"
                          id="leadTimeMM"
                          maxlength="2"
                          v-validate="'numeric'"
                        />
                        <label>(MM)</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-7 d-flex align-items-center">
                <div class="pl-4 d-flex align-items-center">
                  <!-- <div
                    class="form-check mx-3"
                    v-for="(item, showTypeIndex) in ShowTypeArray"
                    :key="showTypeIndex"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="
                        cinema_obj.cinemaShowType.findIndex(
                          (x) => x.booking_type_id == item.booking_type_id
                        ) !== -1
                      "
                      :id="`showtype${cinema_index}${showTypeIndex}`"
                      @change="saveShowType(item, cinema_obj)"
                    />
                    <label
                      class="form-check-label"
                      :for="`showtype${cinema_index}${showTypeIndex}`"
                    >
                      {{ item.screening_name }}
                    </label>
                  </div> -->
                  <b-form-checkbox
                    v-for="(item, showTypeIndex) in ShowTypeArray"
                    :key="showTypeIndex"
                    :id="`showtype${cinema_index}${showTypeIndex}`"
                    :checked="
                      cinema_obj.cinemaShowType.findIndex(
                        (x) => x.booking_type_id == item.booking_type_id
                      ) !== -1
                    "
                    @change="saveShowType(item, cinema_obj)"
                    class="j-checkbox mx-3 mb-3"
                  >
                    <div class="text-capitalize">
                      {{ item.screening_name }}
                    </div>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div class="p-3">
            <!-- <span class="font-weight-bold text-blue fs-16">Movie Banner</span> -->
            <table class="list-view-table no-fl mb-3">
              <thead>
                <tr>
                  <th>Screen Name</th>
                  <th>Lead Time</th>
                  <th class="pl-4">Screening Type</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    screen_obj, screen_index
                  ) in cinema_obj.new_screen_unique"
                  :key="screen_index"
                >
                  <td class="screenNameCol">
                    {{ screen_obj.screen_name }}
                  </td>
                  <td class="w-25">
                    <div class="row pr-5">
                      <div class="col-6 p-1">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                            style="text-align:right"
                              placeholder="."
                              v-model="screen_obj.lead_hr"
                              type="text"
                              name="leadTimeHH"
                              id="leadTimeHH"
                              v-validate="'numeric'"
                            />
                            <label>(HH)</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 p-1">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                            style="text-align:right"
                              placeholder="."
                              v-model="screen_obj.lead_mn"
                              type="text"
                              name="leadTimeMM"
                              id="leadTimeMM"
                              maxlength="2"
                              v-validate="'numeric'"
                            />
                            <label>(MM)</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <div
                        class="form-check mx-3"
                        v-for="(item, showTypeIndex) in ShowTypeArray"
                        :key="showTypeIndex"
                        v-if="false"
                      >
                        <input
                          class="form-check-input j-checkbox"
                          type="checkbox"
                          :checked="
                            screen_obj.screenShowType.findIndex(
                              (x) => x.booking_type_id == item.booking_type_id
                            ) !== -1
                          "
                          :id="`showtype${cinema_index}${screen_index}${showTypeIndex}`"
                          @change="saveScreenShowType(item, screen_obj)"
                        />
                        <label
                          class="form-check-label"
                          :for="`showtype${cinema_index}${screen_index}${showTypeIndex}`"
                        >
                          {{ item.screening_name }}
                        </label>
                      </div>
                      <b-form-checkbox
                        v-for="(item, showTypeIndex) in ShowTypeArray"
                        :key="showTypeIndex"
                        :id="`showtype${cinema_index}${screen_index}${showTypeIndex}`"
                        :checked="
                          screen_obj.screenShowType.findIndex(
                            (x) => x.booking_type_id == item.booking_type_id
                          ) !== -1
                        "
                        @change="saveScreenShowType(item, screen_obj)"
                        class="j-checkbox mx-3 mb-3"
                      >
                        <div class="text-capitalize">
                          {{ item.screening_name }}
                        </div>
                      </b-form-checkbox>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
             <p class="error_message fs-14 ml-3">*Highest lead time will have priority in on demand movie schedule</p>
          </div>
        </div>
        <div class="d-flex justify-content-center my-4">
          <button class="btn-blue" @click.prevent.stop="saveSetting">
            {{ $t("Save & Close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import { uniqBy, throttle, debounce } from "lodash";
import VueTimepicker from "vue2-timepicker";
import MyCinemaService from "@/services/MyCinemaService";
import "vue2-timepicker/dist/VueTimepicker.css";
import Multiselect from "vue-multiselect";

import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
    VueTimepicker,
    Multiselect,
  },
  data() {
    return {
      cinema_id: null,
      shiftsCLoseValues: [],
      submitted: "N",
      debounce: null,
      src_id2: null,
      manager_user_id2: null,
      status: "Y",
      payloadStatus: "Y",
      searchValue: "",
      selectedIndex: null,
      getSelectedDate: null,
      //
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
      movieDetailList: [],
      Cinemas: [],
      CinemasGroupedByRegion: [],
      ShowTypeArray: [
        {
          booking_type_id: "3",
          screening_name: "Private",
        },
        {
          booking_type_id: "1",
          screening_name: "Confirmed",
        },
        {
          booking_type_id: "2",
          screening_name: "CrowdSource",
        },
      ],
      SearchLicenceList: ["All", "Licenced", "UnLicenced"],
      searchType: "All",
    };
  },

  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    // this.getShiftCloseList({});
    this.getMovieDetailList();
    this.getCinemasList();

    const { user_id, role_name } = this.secureStore.get("USINFO");
    console.log("role nammee", role_name);
  },
  mounted() {},
  methods: {
    saveSetting() {
      let loader = this.$loading.show();
      this.Cinemas.map((x) => {
        x.lead_hr = x.lead_hr ? x.lead_hr : "00";
        x.lead_mn = x.lead_mn ? x.lead_mn : "00";
        x.new_screen_unique.map((y) => {
          y.lead_hr = y.lead_hr ? y.lead_hr : "00";
          y.lead_mn = y.lead_mn ? y.lead_mn : "00";
        });
      });

      let payload = {
        Cinema_Detail: this.Cinemas,
      };
      MasterService.SaveOnDemandSetting(payload)
        .then((resp) => {
          const { data } = resp;

          this.$toasted.show(data.message || "Opps! Something went wrong");
          this.$router.push({
            path: "/",
          });
          this.getCinemasList();
          loader.hide();
        })
        .catch(this._CatchError);
    },
    getIntervals(movieIndex) {
      let start_time = this.movieDetailList[movieIndex]["start_time"];
      let end_time = this.movieDetailList[movieIndex]["end_time"];
      let interval_time = this.movieDetailList[movieIndex]["interval_time"];

      start_time = new Date(
        moment(start_time, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      end_time = new Date(
        moment(end_time, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      console.log(start_time, end_time, moment(end_time).isAfter(start_time));

      if (
        start_time &&
        end_time &&
        interval_time &&
        moment(end_time).isAfter(start_time)
      ) {
        var start = moment(start_time, "YYYY-MM-DD hh:mm a");
        var end = moment(end_time, "YYYY-MM-DD hh:mm a");

        if (interval_time == "00") {
          interval_time = 60;
        }

        // round starting minutes up to nearest 15 (12 --> 15, 17 --> 30)
        // note that 59 will round up to 60, and moment.js handles that correctly
        start.minutes(Math.ceil(start.minutes() / 15) * 15);

        var result = [];

        var current = moment(start);

        while (current <= end) {
          result.push(current.format("HH:mm"));
          current.add(interval_time, "minutes");
        }
        console.log(result, "fsdfsdfsdfsd");
        return result;
      } else {
        // console.log("fsfsdf");
        return null;
      }
    },
    saveShowType(item, cinemaItem) {
      let findIndeNew = cinemaItem["cinemaShowType"].findIndex((x) => {
        return x.booking_type_id == item.booking_type_id;
      });
      if (findIndeNew >= 0) {
        cinemaItem["cinemaShowType"].splice(findIndeNew, 1);
      } else {
        cinemaItem["cinemaShowType"].push(item);
      }
      console.log(cinemaItem["cinemaShowType"], "fdfsdfsd");
    },
    saveScreenShowType(item, screenItem) {
      let findIndeNew = screenItem["screenShowType"].findIndex((x) => {
        return x.booking_type_id == item.booking_type_id;
      });
      if (findIndeNew >= 0) {
        screenItem["screenShowType"].splice(findIndeNew, 1);
      } else {
        screenItem["screenShowType"].push(item);
      }
      console.log(screenItem["screenShowType"], "fdfsdfsd");
    },
    onClickCinemaPill: function (cinema, DistributorItem) {
      console.log("onClickCinemaPill called", cinema, DistributorItem);
      let selected_cinemas = DistributorItem.selected_cinema;
      let doesExist = selected_cinemas.findIndex(
        (x) => x.cine_id == cinema.cine_id
      );
      if (doesExist !== -1) {
        selected_cinemas.splice(doesExist, 1);
      } else {
        selected_cinemas.push(cinema);
      }

      console.log(
        "DistributorItem.selected_cinema",
        DistributorItem.selected_cinema
      );
    },
    onClickCinemaRegion: function (cinemas, DistributorItem) {
      console.log(cinemas, DistributorItem);
      let selected_cinemas = DistributorItem.selected_cinema;
      const doesAllExist = cinemas.every((c) => {
        if (selected_cinemas.findIndex((x) => x.cine_id == c.cine_id) > -1) {
          return true;
        }
        return false;
      });

      if (doesAllExist) {
        DistributorItem.selected_cinema = selected_cinemas.filter((x) => {
          if (cinemas.findIndex((c) => c.cine_id == x.cine_id) > -1) {
            return false;
          }
          return true;
        });
      } else {
        cinemas.forEach((c) => {
          if (
            selected_cinemas.findIndex((x) => x.cine_id == c.cine_id) === -1
          ) {
            selected_cinemas.push(c);
          }
        });
      }
    },
    goToRoute: function (path, { usl_id }) {
      this.$router.push({
        path: path,
        query: {
          shift_id: usl_id,
        },
      });
    },
    onSetValueSrc_id: function (e, values, Tempstatus, manager_user_id, index) {
      this.src_id2 = values;
      this.manager_user_id2 = manager_user_id;
      this.status = Tempstatus;
      this.selectedIndex = index;
      if (status === "N") {
      } else {
      }
      this.$refs.test.show();
      // this.$nextTick(() => {
      //   this.$forceUpdate();
      // });
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      let body = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };

      MasterService.GetCinemasMovieLicence()
        .then((resp) => {
          const { data } = resp;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;

            this.CinemasGroupedByRegion = _.toPairs(
              _.groupBy(
                data.Records.filter((x) => x.region_id),
                "region_id"
              )
            );
            console.log(
              "this.CinemasGroupedByRegion",
              this.CinemasGroupedByRegion
            );
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    onChangeStatus: function (value, index) {
      const { user_id, role_name } = this.secureStore.get("USINFO");
      if (user_id == value.manager_user_id && role_name == "Super Admin") {
        if (confirm("Do you really want to update?")) {
          CinemasService.UpdateShiftClose(value);
        } else {
          if (this.shiftsCLoseValues[index].scr_approval_status == "N") {
            this.shiftsCLoseValues[index].scr_approval_status = "N";
          } else {
            this.shiftsCLoseValues[index].scr_approval_status = "Y";
          }
        }
      }
    },
    onSearch() {
      // this.searchValue = event.target.value;
      // setTimeout(() => {
      this.currentPage = 1;

      this.getMovieDetailList();
      // }, 1000);
    },
    getShiftCloseList(params) {
      const { changeDate, newCurrentPage } = params;
      this.shiftsCLoseValues = [];
      let payload = {
        currentPage: changeDate ? newCurrentPage : this.currentPage,
        limit: this.perPage,
        searchValue: this.searchValue,
        date: this.getSelectedDate,
        cinema_id: this.cinema_id,
      };
      CinemasService.GetShiftClose(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.shiftsCLoseValues = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getMovieDetailList() {
      this.movieDetailList = [];
      let payload = {
        currentPage: this.currentPage,
        limit: this.perPage,
        search: this.searchValue,
        searchType: this.searchType,
      };
      CinemasService.GetMovieDetailList(payload)
        .then((response) => {
          const { data } = response;
          console.log(data);
          if (data && data.status && data.Records.hasOwnProperty("data")) {
            if (data.Records.data.length > 0) {
              this.movieDetailList = data.Records.data;
              console.log(this.movieDetailList);
              if (data.Records.pagination.hasOwnProperty("total")) {
                if (data.Records.pagination.total >= 10) {
                  this.rows = data.Records.pagination.total;
                } else {
                  this.rows = data.Records.pagination.total;
                  this.selectedvalue = data.Records.pagination.total;
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onClearDate: function () {
      this.getSelectedDate = null;
      this.getShiftCloseList({});
    },
    onSelectDate: function (value) {
      this.getSelectedDate = moment(value).format("YYYY-MM-DD");
      this.getShiftCloseList({ newCurrentPage: 1, fromDate: true });
    },
    okUpdateStatus() {
      const { user_id, role_name } = this.secureStore.get("USINFO");
      if (this.status == "Y") {
        this.payloadStatus = "N";
      } else {
        this.payloadStatus = "Y";
      }
      if (user_id == this.manager_user_id2 && role_name == "Super Admin") {
        this.$refs.test.hide();
        let payload = {
          scr_id: this.src_id2,
          scr_approval_status: this.payloadStatus,
        };
        CinemasService.UpdateShiftClose(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    cancelUpdateStatus() {
      if (
        this.shiftsCLoseValues[this.selectedIndex].scr_approval_status == "Y"
      ) {
        this.shiftsCLoseValues[this.selectedIndex].scr_approval_status = "N";
      } else {
        this.shiftsCLoseValues[this.selectedIndex].scr_approval_status = "Y";
      }
      this.$refs.test.hide();
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getMovieDetailList();
      } else {
        this.currentPage = event;
        this.getMovieDetailList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
  },
};
</script>

<style scoped>
.movie-license-collapse {
  background-color: #e6e6f8;
  padding: 8px 16px;
}

.cinemaBox {
  padding: 0px 30px 5px 30px;
}

.onDemandSection .input-material input {
  height: 38px !important;
  /* width: 100px !important; */
  min-height: auto !important;
}

.onDemandSection {
  border: 1px solid lightgray;
  border-radius: 10px;
  margin-top: 20px;
  padding: 20px 0px 10px 0px;
  box-shadow: 0 0 7px #8080802b;
}

.no-fl {
  table-layout: unset !important;
}

.screenNameCol {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/MyCinemaComponents/MultiScheduling/OnDemandSetting.vue